import React from 'react';
import {
  Anchor,
  Connect,
  Explain,
  GeoCompass,
  Inquiry,
  IIconProps,
  Observe,
  Timeline,
  Writing,
} from '@/../images/react';
import { SlideShow } from './UnitSlideShowCardTypes';

const ICON_MAPPING = {
  connecting_the_sciences: Connect,
  explaining_the_unit_anchoring_phenomenon: Anchor,
  geography_challenge: GeoCompass,
  inquiry_challenge: Inquiry,
  observing_the_unit_anchoring_phenomenon: Observe,
  performance_assessment: Explain,
  timeline_challenge: Timeline,
  writing_in_the_social_sciences: Writing,
} as const;

export interface IconProps extends IIconProps {
  slideShow: SlideShow;
}

const Icon = ({ slideShow, ...rest }: IconProps) => {
  const IconComponent = ICON_MAPPING[slideShow.unit_type];

  return (
    <IconComponent aria-hidden height={42} width={42} {...rest} />
  );
};

export default Icon;
